<template>
    <label :for="unique" class="field-wrapper focused">
        <span class="label-font label-placeholder" v-if="label">{{ label }}</span>
        <textarea :id="unique" v-html="value" @input="trigger"
            class="form-control form-control-outline" :rows="rows"
            :class="fieldClass"
            ></textarea>
    </label>
</template>

<script>
import FormField from './FormField.js';

export default {
    extends: FormField,
    data: function() {
        return {
            focus: false
        };
    },
    props: {
        value: {
            default: undefined
        },
        label: {
            default: false
        },
        rows: {
            type: Number,
            default: 10
        }
    },
    methods: {
        trigger(v) {
            this.$emit('input', v.target.value);
        }
    },
    created() {
        if (typeof this.value === 'undefined') {
            this.$emit('input', '');
        }
    }
};
</script>
